import React, {
  useEffect,
  useState,
  useRef,
  useMemo,
} from "react";

  import {  Card,  Select,  Button,  message,  Steps,  Space,  Row,  Col,  Grid,  Typography, Input, Tooltip} from "antd";

  import { EditOutlined, DeleteOutlined, CopyOutlined  } from "@ant-design/icons";


  import {  } from "antd";

  import api from "../services/api";

  import TournamentFormModal from "../components/tournaments/TournamentFormModal";
  import MatchFormModal from "../components/matches/MatchFormModal";
  import TeamFormModal from "../components/teams/TeamFormModal";
  import PlayerFormModal from "../components/players/PlayerFormModal";
  import useInningsEngine from "../hooks/useInningsEngine";




  const { Option } = Select;

  /**
   * TEMP – replace with role-based auth later
   */
  const isAdmin = true;

  export default function Ultimate() {
    /* -------------------- STEPS -------------------- */
    const UI_STEPS = {
    MATCH: 1,
    TEAMS: 2,
    TOSS: 3,
    PLAYERS: 4,
    LIVE: 5,
    SUMMARY: 6,
  };

  const [step, setStep] = useState(UI_STEPS.MATCH);


    /* -------------------- DATA -------------------- */
    const [tournaments, setTournaments] = useState([]);

    const [tournamentId, setTournamentId] = useState(null);
    const [matchId, setMatchId] = useState(null);

    const [teamPlayers, setTeamPlayers] = useState({});

    /* -------------------- LIVE -------------------- */
    const [inning, setInning] = useState(null);
    const [batters, setBatters] = useState([]);
    const [bowlers, setBowlers] = useState([]);
    const [teamSlot, setTeamSlot] = useState(null); // "team1" | "team2"

    const [autoCreatedMatch, setAutoCreatedMatch] = useState(null);




    /* -------------------- MODALS -------------------- */
  /* -------------------- MODALS -------------------- */
  const [showTournamentModal, setShowTournamentModal] = useState(false);
  const [showMatchModal, setShowMatchModal] = useState(false);
  const [showTeamModal, setShowTeamModal] = useState(false);
  // 🔥 ADD THIS
  const [teamCreateTarget, setTeamCreateTarget] = useState(null);
  const [teamsForMatch, setTeamsForMatch] = useState([]);
  const [editingPlayer, setEditingPlayer] = useState(null);
  // 🔥 Player Modal
  const [isPlayerModalOpen, setIsPlayerModalOpen] = useState(false);
  const inningsEndHandledRef = useRef(false);


  const [inningsNo, setInningsNo] = useState(1);
  const [target, setTarget] = useState(null);
  const [firstInningsScore, setFirstInningsScore] = useState(null);
  const [matchResult, setMatchResult] = useState(null);
  const [isInningsBreak, setIsInningsBreak] = useState(false);
  const [secondInningsScore, setSecondInningsScore] = useState(null);
  const [matchOvers, setMatchOvers] = useState(20);
  const [inningsWithBalls, setInningsWithBalls] = useState([]);
  const [teamA, setTeamA] = useState(null);
  const [teamB, setTeamB] = useState(null);
  const [selectedTeams, setSelectedTeams] = useState({
    team1: null,
    team2: null,
  });
  const [engineKey, setEngineKey] = useState(1);
  /* ---------------- WICKET UI ---------------- */
  const [showWicketModal, setShowWicketModal] = useState(false);
  const [selectedWicketType, setSelectedWicketType] = useState(null);
  const [selectedNextBatter, setSelectedNextBatter] = useState(null);
  const [selectedFielder, setSelectedFielder] = useState(null);


  /* ---------------- BOWLER UI ---------------- */
  const [showBowlerSelect, setShowBowlerSelect] = useState(false);
  const [selectedNextBowler, setSelectedNextBowler] = useState(null);
  const [lastSavedBallId, setLastSavedBallId] = useState(null);
  const [runOutBatsman, setRunOutBatsman] = useState(null);


  /* ---------------- SUMMARY DATA ---------------- */
const [summaryMatch, setSummaryMatch] = useState(null);
const [summaryMatchTeams, setSummaryMatchTeams] = useState([]);
const [summaryInnings, setSummaryInnings] = useState([]);
const [summaryBallsByInning, setSummaryBallsByInning] = useState({});
const [summaryLoading, setSummaryLoading] = useState(false);




  // [team_id, team_id]
  const [matchCompleted, setMatchCompleted] = useState(false);

  const [matchState, setMatchState] = useState("scheduled");
  

  /*
  scheduled
  toss_pending
  toss_completed
  innings_1_live
  innings_break
  innings_2_live
  completed
  */

  const [tossWinner, setTossWinner] = useState(null);
  const [tossDecision, setTossDecision] = useState(null); // "bat" | "bowl"

  const { Text } = Typography;
  const savingBallRef = useRef(false);
  const wicketUpdateLockedRef = useRef(false);


  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();


  const STEP_ITEMS = [
  { key: 1, title: "Tournaments" },
  { key: 2, title: "Teams" },
  { key: 3, title: "Toss" },
  { key: 4, title: "Players" },
  { key: 5, title: "Live" },
  { key: 6, title: "Summary" },
];

    /* -------------------- INITIAL LOAD -------------------- */
    useEffect(() => {
      loadTournaments();
    }, []);

useEffect(() => {
  if (step === UI_STEPS.TEAMS) {
    loadAllTeams();
  }
}, [step]);




  useEffect(() => {
    console.log({
      teamA,
      teamB,
      teamsForMatch,
    });
  }, [teamA, teamB, teamsForMatch]);


    const loadTournaments = async () => {
      const res = await api.get("/tournaments");
      setTournaments(res.data.data || []);
    };


 

const overlayUrl = `https://overlay.x11-sports.com/?matchId=${matchId}`; 

const safeTeamsForMatch = useMemo(() => {
  if (!Array.isArray(teamsForMatch)) return [];
  return teamsForMatch.map(t => ({
    team_id: t.team_id,
    name: t.name || t.Team?.name || "Unknown Team",
  }));
}, [teamsForMatch]);



useEffect(() => {
  if (step !== UI_STEPS.SUMMARY || !matchId) return;

  const loadSummary = async () => {
    try {
      setSummaryLoading(true);

      // 1️⃣ Match
      const matchRes = await api.get(`/matches/${matchId}`);
      setSummaryMatch(matchRes.data.data);

      // 2️⃣ Match teams
      const mtRes = await api.get(`/matchteams/${matchId}`);
      setSummaryMatchTeams(mtRes.data.data || []);

      // 3️⃣ Innings
      const innRes = await api.get(`/innings`, {
        params: { match_id: matchId },
      });
      const inns = innRes.data.data || [];
      setSummaryInnings(inns);

      // 4️⃣ Balls per inning
      const ballsMap = {};
      await Promise.all(
        inns.map(async (inn) => {
          const bRes = await api.get(`/balls/inning/${inn.inning_id}`);
          ballsMap[inn.inning_id] = bRes.data.data || [];
        })
      );
      setSummaryBallsByInning(ballsMap);

    } catch (e) {
      console.error("Summary load failed", e);
      message.error("Failed to load match summary");
    } finally {
      setSummaryLoading(false);
    }
  };

  loadSummary();
}, [step, matchId]);

const getTeamNameById = (teamId) => {
  const mt = summaryMatchTeams.find(t => t.team_id === teamId);
  return mt?.Team?.name || mt?.team?.name || `Team ${teamId}`;
};

const getInningTotals = (inning) => {
  const balls = summaryBallsByInning[inning.inning_id] || [];
  const runs = balls.reduce(
    (s, b) => s + (b.runs || 0) + (b.extras || 0),
    0
  );
  const wickets = balls.filter(b => b.wicket).length;
  const overs = `${Math.floor(balls.length / 6)}.${balls.length % 6}`;
  return { runs, wickets, overs };
};

const getMatchResultText = () => {
  if (!summaryInnings || summaryInnings.length < 2)
    return "Result Pending";

  const i1 = getInningTotals(summaryInnings[0]);
  const i2 = getInningTotals(summaryInnings[1]);

  const team1 = getTeamNameById(summaryInnings[0].batting_team_id);
  const team2 = getTeamNameById(summaryInnings[1].batting_team_id);

  if (i2.runs > i1.runs)
    return `${team2} won by ${10 - i2.wickets} wickets`;

  if (i2.runs < i1.runs)
    return `${team1} won by ${i1.runs - i2.runs} runs`;

  return "Match Tied";
};


const innings = useInningsEngine({
  battingTeam:
    step === UI_STEPS.LIVE
      ? { players: batters }
      : { players: [] },

  bowlingTeam:
    step === UI_STEPS.LIVE
      ? { players: bowlers }
      : { players: [] },

  oversLimit: matchOvers,
  target: inningsNo === 2 ? target : null,
  enabled:
    matchState === "innings_1_live" ||
    matchState === "innings_2_live",
  resetKey: engineKey,
});


/* ================= INNINGS UI EFFECTS ================= */

/* 🟥 WICKET DETECTION */
useEffect(() => {
  if (innings?.pendingWicket) {
    setShowWicketModal(true);
  }
}, [innings?.pendingWicket]);

/* 🟦 OVER COMPLETION DETECTION */
useEffect(() => {
  if (innings?.isOverComplete) {
    setShowBowlerSelect(true);
  }
}, [innings?.isOverComplete]);




    useEffect(() => {
    console.log("teamsForMatch:", teamsForMatch);
  }, [teamsForMatch]);
  // 🔧 Helper: get team object by id
  const getTeamById = (teamId) =>
    teamsForMatch.find((t) => t.team_id === teamId);

    const loadTeamPlayers = async (teamId) => {
      const res = await api.get("/team-players", {
        params: { team_id: teamId },
      });
      setTeamPlayers((prev) => ({
        ...prev,
        [teamId]: res.data.data || [],
      }));
    };

  

  const startMatch = async () => {
    if (matchCompleted) return;

    const { batting, bowling } = resolveTeamsFromToss();
    if (!batting || !bowling) {
      message.error("Toss not completed");
      return;
    }

    const res = await api.post("/innings", {
      match_id: matchId,
      batting_team_id: batting.team_id,
      bowling_team_id: bowling.team_id,
    });

    setInning(res.data.data);

    await loadTeamPlayers(batting.team_id);
    await loadTeamPlayers(bowling.team_id);

    setBatters(
      (teamPlayers[batting.team_id] || []).map(p => p.Player)
    );
    setBowlers(
      (teamPlayers[bowling.team_id] || []).map(p => p.Player)
    );

    setMatchState("innings_1_live");
    setStep(UI_STEPS.LIVE);
  };


useEffect(() => {
  if (
    step !== UI_STEPS.LIVE ||
    !innings ||
    batters.length < 2 ||
    bowlers.length < 1
  ) return;

  // 🔥 FORCE RESET ON NEW INNINGS
  innings.setStriker(null);
  innings.setNonStriker(null);
  innings.setBowler(null);

  // ⏳ Let state clear first
  setTimeout(() => {
    innings.setStriker(batters[0]);
    innings.setNonStriker(batters[1]);
    innings.setBowler(bowlers[0]);
  }, 0);

}, [
  step,
  engineKey,   // 🔥 THIS IS THE FIX
  batters,
  bowlers,
]);


  const normalizeMatchTeams = (matchTeams) => {
    return matchTeams.map(mt => ({
      team_id: mt.team_id,
      name: mt.Team.name,
    }));
  };


  const loadAllTeams = async () => {
  try {
    const res = await api.get("/teams");
    setTeamsForMatch(res.data.data || []);
  } catch (e) {
    console.error("Failed to load teams", e);
    message.error("Failed to load teams");
  }
};


useEffect(() => {
  if (
    step !== UI_STEPS.LIVE ||
    !innings ||
    innings.bowler ||
    bowlers.length === 0
  ) return;

  innings.setBowler(bowlers[0]);
}, [step, innings, bowlers]);



  const saveInningsSummary = async () => {
    if (!inning) return;

    try {
      await api.put(`/innings/${inning.inning_id}`, {
        runs: innings.score,
        wickets: innings.wickets,
        overs: `${innings.overs}.${innings.balls}`,
        status: "completed", // 🔥 THIS IS THE KEY
      });
    } catch (e) {
      console.error("Failed to save innings summary", e);
      message.error("Innings summary not saved");
    }
  };

 useEffect(() => {
  if (!innings.isInningsOver) {
    inningsEndHandledRef.current = false;
    return;
  }

  if (inningsEndHandledRef.current) return;
  inningsEndHandledRef.current = true;

  const handleInningsEnd = async () => {
    await saveInningsSummary();

    await api.put(`/innings/${inning.inning_id}/end`);

    // 🏏 FIRST INNINGS END
    if (inningsNo === 1) {
      const score = innings.score;

      setFirstInningsScore(score);
      setTarget(score + 1);
      setIsInningsBreak(true);

      // ❌ DO NOT start second innings here
      return;
    }

    // 🏏 SECOND INNINGS END → MATCH COMPLETE
    if (inningsNo === 2) {
      const finalScore = innings.score;

      let result;
      if (finalScore >= target) result = "Batting team won";
      else if (finalScore === firstInningsScore) result = "Match Tied";
      else result = "Bowling team won";

      setMatchResult(result);
      setMatchCompleted(true);

      await api.put(`/matches/${matchId}`, {
        status: "completed",
        result,
      });

      setStep(UI_STEPS.SUMMARY);
    }
  };

  handleInningsEnd();
}, [innings.isInningsOver]);

const startSecondInnings = async () => {
  try {
    if (inningsNo !== 1) return;

    // 🔥 CAPTURE CURRENT ROLES
    const newBattingTeam = inning.bowling_team_id;
    const newBowlingTeam = inning.batting_team_id;


    // 🔥 CREATE NEW INNING (BACKEND AUTHORITATIVE)
    const res = await api.post("/innings", {
      match_id: matchId,
      batting_team_id: newBattingTeam,
      bowling_team_id: newBowlingTeam,
    });

    // 🔥 UPDATE STATE (NO NESTED SETTERS)
    setInning(res.data.data);
    setInningsNo(2);

    setTeamA(newBattingTeam);
    setTeamB(newBowlingTeam);

    // 🔥 RESET ENGINE
    setEngineKey(k => k + 1);

    // 🔥 LOAD PLAYERS FOR NEW ROLES
    const batRes = await api.get("/team-players", {
      params: { team_id: newBattingTeam },
    });
    const bowlRes = await api.get("/team-players", {
      params: { team_id: newBowlingTeam },
    });

    setBatters(batRes.data.data.map(p => p.Player));
    setBowlers(bowlRes.data.data.map(p => p.Player));

    setMatchState("innings_2_live");
    setIsInningsBreak(false);
    setStep(UI_STEPS.LIVE);

  } catch (e) {
    console.error(e);
    message.error("Failed to start 2nd innings");
  }

};







  const resumeMatchIfAny = async (mid) => {
    try {
      // 1️⃣ Fetch innings for match
      const res = await api.get(`/innings/match/${mid}`);
      const inningsList = res.data.data || [];

      if (!inningsList.length) return false;

      // 🔴 MATCH COMPLETED → STEP 5
      const allCompleted = inningsList.every(
        i => i.status === "completed"
      );

      if (allCompleted) {
        setMatchCompleted(true); 
        setStep(UI_STEPS.SUMMARY);;
        message.info("Match completed. Showing summary.");
        return true;
      }

      // 2️⃣ Get live or last inning
      const currentInning =
        inningsList.find(i => i.status === "live") ||
        inningsList[inningsList.length - 1];

      if (!currentInning) return false;

      setInning(currentInning);
      setInningsNo(inningsList.length);

      // 3️⃣ Load players
      const batTeamId = currentInning.batting_team_id;
      const bowlTeamId = currentInning.bowling_team_id;

      await loadTeamPlayers(batTeamId);
      await loadTeamPlayers(bowlTeamId);

      const bat = (teamPlayers[batTeamId] || []).map(p => p.Player);
      const bowl = (teamPlayers[bowlTeamId] || []).map(p => p.Player);

      setBatters(bat);
      setBowlers(bowl);

      // 4️⃣ Restore striker / bowler
      setTimeout(() => {
        innings.setStriker(
          bat.find(p => p.player_id === currentInning.striker_id)
        );
        innings.setNonStriker(
          bat.find(p => p.player_id === currentInning.non_striker_id)
        );
        innings.setBowler(
          bowl.find(p => p.player_id === currentInning.current_bowler_id)
        );
      }, 0);

      // 🟡 FIRST INNINGS COMPLETE → BREAK
      if (
        inningsList.length === 1 &&
        currentInning.status === "completed"
      ) {
        setFirstInningsScore(currentInning.runs);
        setTarget(currentInning.runs + 1);
        setInningsNo(2);
        setIsInningsBreak(true);
        setStep(UI_STEPS.LIVE);
        message.info("Match resumed at innings break");
        return true;
      }

      // 🔁 SECOND INNINGS LIVE
      if (inningsList.length === 2) {
        const first = inningsList[0];
        setTarget(first.runs + 1);
        setFirstInningsScore(first.runs);
        setInningsNo(2);
      }

      setStep(UI_STEPS.LIVE);
      message.success("Live match resumed");
      return true;

    } catch (e) {
      console.error("Resume failed", e);
      return false;
    }
  };


const createMatchFromTeams = async (team1Id, team2Id) => {
  const team1 = teamsForMatch.find(t => t.team_id === team1Id);
  const team2 = teamsForMatch.find(t => t.team_id === team2Id);

  if (!team1 || !team2) {
    message.error("Unable to resolve team names");
    return null;
  }

  const matchName = `${team1.name} vs ${team2.name}`;

  const res = await api.post("/matches", {
    tournament_id: tournamentId,
    name: matchName,
    overs: matchOvers || 20,
    status: "scheduled",
  });

  setMatchId(res.data.data.match_id);
  setAutoCreatedMatch(res.data.data);

  return res.data.data;
};




    const resolveTeamsFromToss = () => {
      const winner = selectedMatchTeams.find(
        t => t.team_id === tossWinner
      );
      const loser = selectedMatchTeams.find(
        t => t.team_id !== tossWinner
      );

      if (!winner || !loser) return {};

      if (tossDecision === "bat") {
        return { batting: winner, bowling: loser };
      }
      return { batting: loser, bowling: winner };
    };


  const getBattingStats = (balls) => {
    const stats = {};

    balls.forEach(b => {
      if (!b.batsman_id) return;

      if (!stats[b.batsman_id]) {
        stats[b.batsman_id] = {
          runs: 0,
          balls: 0,
          fours: 0,
          sixes: 0,
          out: false,
        };
      }

      stats[b.batsman_id].runs += b.runs;
      if (!b.extra_type) stats[b.batsman_id].balls += 1;
      if (b.runs === 4) stats[b.batsman_id].fours += 1;
      if (b.runs === 6) stats[b.batsman_id].sixes += 1;
      if (b.wicket) stats[b.batsman_id].out = true;
    });

    return stats;
  };


  const getBowlingStats = (balls) => {
    const stats = {};

    balls.forEach(b => {
      if (!b.bowler_id) return;

      if (!stats[b.bowler_id]) {
        stats[b.bowler_id] = {
          runs: 0,
          balls: 0,
          wickets: 0,
        };
      }

      stats[b.bowler_id].runs += b.runs + (b.extras || 0);
      if (!b.extra_type) stats[b.bowler_id].balls += 1;
      if (b.wicket) stats[b.bowler_id].wickets += 1;
    });

    return stats;
  };


  useEffect(() => {
    if (
      !innings?.lastBall ||
      !inning ||
      savingBallRef.current ||
      matchCompleted ||
      wicketUpdateLockedRef.current
    ) {
      return;
    }


    savingBallRef.current = true;

    const b = innings.lastBall;

    const payload = {
      match_id: matchId,
      inning_id: inning.inning_id,
      over: b.over,
      ball_number: b.ball === 0 ? 6 : b.ball,
      batsman_id: b.striker?.player_id,
      non_striker_id: b.nonStriker?.player_id,
      bowler_id: b.bowler?.player_id,
      runs: b.runs || 0,
      extras: b.extras || 0,
      extra_type: b.extraType || null,
      wicket: b.isWicket || false,
      wicket_type: b.wicketType || null,
      fielder_id: b.fielderId || null,
    };

    console.log("✅ SAVING BALL", payload);

    api
      .post("/balls", payload)
      .then((res) => {
        setLastSavedBallId(res.data.data.ball_id);

        return api.put(`/innings/${inning.inning_id}`, {
          striker_id: payload.batsman_id,
          non_striker_id: payload.non_striker_id,
          current_bowler_id: payload.bowler_id,
        });
      })

      .catch((err) => {
        console.error("❌ BALL SAVE FAILED", err.response?.data || err);
      })
      .finally(() => {
        savingBallRef.current = false;
      });

  }, [innings?.lastBall?.timestamp]);// 🔥 THIS IS IMPORTANT


  const loadMatchTeamsByMatch = async (mid) => {
    const res = await api.get(`/matchteams/${mid}`);
    return res.data.data || [];
  };


  const selectedMatchTeams = useMemo(() => {
  if (!selectedTeams.team1 || !selectedTeams.team2) return [];

  return safeTeamsForMatch.filter(t =>
    t.team_id === selectedTeams.team1 ||
    t.team_id === selectedTeams.team2
  );
}, [safeTeamsForMatch, selectedTeams]);



const MobileStepBreadcrumbs = ({ currentStep }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        overflowX: "auto",
        whiteSpace: "nowrap",
        fontSize: 13,
        paddingBottom: 8,
        scrollbarWidth: "none",
      }}
    >
      {STEP_ITEMS.map((step, index) => {
        const isActive = step.key === currentStep;
        const isCompleted = step.key < currentStep;

        return (
          <React.Fragment key={step.key}>
            <span
              style={{
                color: isActive
                  ? "#1677ff"
                  : isCompleted
                  ? "#1677ff"
                  : "#999",
                fontWeight: isActive ? 600 : 400,
                cursor: isCompleted ? "pointer" : "default",
              }}
            >
              {step.title}
            </span>

            {/* Separator */}
            {index < STEP_ITEMS.length - 1 && (
              <span
                style={{
                  margin: "0 8px",
                  color: "#ccc",
                }}
              >
                &gt;
              </span>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};




    /* -------------------- UI -------------------- */
  return (
    <div
      style={{
        padding: screens.md ? "12px 12px 24px" : "8px",
        maxWidth: 1200,
        margin: "0 auto",
      }}
>

      {/* ---------------- STEP INDICATOR ---------------- */}
      <div style={{ marginBottom: screens.md ? 16 : 8 }}>
        {screens.md ? (
          <Steps
            current={step - 1}
            size="small"
            items={STEP_ITEMS.map((s) => ({ title: s.title }))}
          />
        ) : (
          <MobileStepBreadcrumbs currentStep={step} />
        )}
      </div>


      {/* ================= STEP 1 ================= */}
{step === UI_STEPS.MATCH && (
<Card
  bordered={false}
  bodyStyle={{
    padding: screens.md ? 16 : 8,
  }}
  title={
    screens.md ? (
      "Tournaments"
    ) : (
      <div style={{ fontSize: 16, fontWeight: 600 }}>
        Tournaments
      </div>
    )
  }
  extra={
    screens.md &&
    isAdmin && (
      <Button type="primary" onClick={() => setShowTournamentModal(true)}>
        + Create Tournament
      </Button>
    )
  }
>
  {/* MOBILE ACTION BUTTON */}
  {!screens.md && isAdmin && (
    <div style={{ marginBottom: 8 }}>
      <Button
        type="primary"
        block
        onClick={() => setShowTournamentModal(true)}
      >
        + Create Tournament
      </Button>
    </div>
  )}
<Row gutter={[screens.md ? 16 : 8, screens.md ? 16 : 8]}>
  {tournaments.map((t) => (
    <Col xs={24} key={t.tournament_id}>
      <Card
        hoverable
        bodyStyle={{ padding: screens.md ? 16 : 12 }}
        style={{ borderRadius: 12 }}
        onClick={() => {
          setTournamentId(t.tournament_id);

          // 🔥 RESET MATCH STATE
          setMatchId(null);
          setAutoCreatedMatch(null);
          setSelectedTeams({ team1: null, team2: null });
          setTossWinner(null);
          setTossDecision(null);
          setInning(null);
          setMatchCompleted(false);
          setMatchState("scheduled");

          setStep(UI_STEPS.TEAMS);
        }}
      >
        {/* HEADER ROW */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: 8,
          }}
        >
          {/* LEFT: NAME + LOCATION */}
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 16, fontWeight: 600 }}>
              {t.name}
            </div>

            {t.location && (
              <Text type="secondary" style={{ fontSize: 12 }}>
                {t.location}
              </Text>
            )}
          </div>

          {/* RIGHT: ACTION ICONS */}
          {isAdmin && (
            <div
              style={{
                display: "flex",
                gap: 12,
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <EditOutlined
                style={{ color: "#1677ff", fontSize: 16 }}
                onClick={() => {
                  setTournamentId(t.tournament_id);
                  setShowTournamentModal(true);
                }}
              />

              <DeleteOutlined
                style={{ color: "#ff4d4f", fontSize: 16 }}
                onClick={() => {
                  message.confirm({
                    title: "Delete Tournament?",
                    content: "This action cannot be undone.",
                    okText: "Delete",
                    okType: "danger",
                    onOk: async () => {
                      await api.delete(`/tournaments/${t.tournament_id}`);
                      loadTournaments();
                      message.success("Tournament deleted");
                    },
                  });
                }}
              />
            </div>
          )}
        </div>
      </Card>
    </Col>
  ))}

  {tournaments.length === 0 && (
    <Col span={24}>
      <Text type="secondary">No tournaments created yet</Text>
    </Col>
  )}
</Row>

  </Card>
)}


{step === UI_STEPS.TEAMS && (
  <Card
    title="Select Teams"
    bordered={false}
    bodyStyle={{ padding: screens.md ? 16 : 8 }}
  >
    <Row gutter={screens.md ? 24 : 12}>

      {/* TEAM 1 */}
      <Col xs={24} md={12}>
        <Card
          size="small"
          title="Team 1"
          bodyStyle={{ padding: 12 }}
        >
          <Space direction="vertical" style={{ width: "100%" }}>
            <Select
              placeholder="Select Team 1"
              value={selectedTeams.team1}
              onChange={(value) =>
                setSelectedTeams((prev) => ({
                  ...prev,
                  team1: value,
                  team2: prev.team2 === value ? null : prev.team2,
                }))
              }
            >
              {safeTeamsForMatch.map((team) => (
                <Option key={team.team_id} value={team.team_id}>
                  {team.name}
                </Option>
              ))}
            </Select>

            <Button
              type="dashed"
              block
              onClick={() => {
                setTeamSlot("team1");
                setShowTeamModal(true);
              }}
            >
              + Create Team
            </Button>
          </Space>
        </Card>
      </Col>

      {/* TEAM 2 */}
      <Col xs={24} md={12}>
        <Card
          size="small"
          title="Team 2"
          bodyStyle={{ padding: 12 }}
        >
          <Space direction="vertical" style={{ width: "100%" }}>
            <Select
              placeholder="Select Team 2"
              value={selectedTeams.team2}
              disabled={!selectedTeams.team1}
              onChange={(value) =>
                setSelectedTeams((prev) => ({
                  ...prev,
                  team2: value,
                }))
              }
            >
              {safeTeamsForMatch
                .filter((t) => t.team_id !== selectedTeams.team1)
                .map((team) => (
                  <Option key={team.team_id} value={team.team_id}>
                    {team.name}
                  </Option>
                ))}
            </Select>

            <Button
              type="dashed"
              block
              disabled={!selectedTeams.team1}
              onClick={() => {
                setTeamSlot("team2");
                setShowTeamModal(true);
              }}
            >
              + Create Team
            </Button>
          </Space>
        </Card>
      </Col>

    </Row>

    {/* CTA */}
    <div
      style={{
        marginTop: 16,
        position: screens.md ? "static" : "sticky",
        bottom: 0,
        background: screens.md ? "transparent" : "#fff",
        paddingTop: screens.md ? 0 : 8,
        zIndex: 10,
      }}
    >
      <Button
        type="primary"
        block
        size={screens.md ? "middle" : "large"}
        disabled={!selectedTeams.team1 || !selectedTeams.team2}
        onClick={async () => {
          const { team1, team2 } = selectedTeams;

          const match = await createMatchFromTeams(team1, team2);
          if (!match) return;

          await api.post("/matchteams", {
            match_id: match.match_id,
            team_id: team1,
            role: "team1",
          });

          await api.post("/matchteams", {
            match_id: match.match_id,
            team_id: team2,
            role: "team2",
          });

          setTeamA(team1);
          setTeamB(team2);

          await loadTeamPlayers(team1);
          await loadTeamPlayers(team2);

          setMatchState("toss_pending");
          setStep(UI_STEPS.TOSS);
        }}
      >
        Confirm Teams →
      </Button>
    </div>
  </Card>
)}




{/* ================= STEP 3 – TOSS ================= */}
{step === UI_STEPS.TOSS && (
  <Card
    title="Toss"
    bordered={false}
    bodyStyle={{ padding: screens.md ? 16 : 8 }}
  >
    <Row gutter={screens.md ? 24 : 12}>

      {/* TOSS WINNER */}
      <Col xs={24} md={12}>
        <Card size="small" title="Who won the toss?" bodyStyle={{ padding: 12 }}>
          <Select
            placeholder="Select team"
            value={tossWinner}
            style={{ width: "100%" }}
            onChange={setTossWinner}
          >
            {selectedMatchTeams.map((team) => (
              <Option key={team.team_id} value={team.team_id}>
                {team.name}
              </Option>
            ))}
          </Select>
        </Card>
      </Col>

      {/* DECISION */}
      <Col xs={24} md={12}>
        <Card size="small" title="Decision" bodyStyle={{ padding: 12 }}>
          <Space style={{ width: "100%" }} direction="vertical">
            <Button
              type={tossDecision === "bat" ? "primary" : "default"}
              block
              onClick={() => setTossDecision("bat")}
            >
              Bat
            </Button>

            <Button
              type={tossDecision === "bowl" ? "primary" : "default"}
              block
              onClick={() => setTossDecision("bowl")}
            >
              Bowl
            </Button>
          </Space>
        </Card>
      </Col>

    </Row>

    {/* CTA */}
    <div
      style={{
        marginTop: 16,
        position: screens.md ? "static" : "sticky",
        bottom: 0,
        background: screens.md ? "transparent" : "#fff",
        paddingTop: screens.md ? 0 : 8,
        zIndex: 10,
      }}
    >
      <Button
        type="primary"
        block
        size={screens.md ? "middle" : "large"}
        disabled={
          !tossWinner ||
          !tossDecision ||
          selectedMatchTeams.length !== 2
        }
        onClick={async () => {
          try {
            await api.put(`/matchteams/match/${matchId}/toss`, {
              toss_winner_team_id: tossWinner,
              toss_decision: tossDecision,
            });

            const { data } = await api.get(`/matchteams/${matchId}`);
            const matchTeams = data.data;

            const battingTeam = matchTeams.find(
              (t) => t.batting_order === 1
            );
            const bowlingTeam = matchTeams.find(
              (t) => t.batting_order === 2
            );

            if (!battingTeam || !bowlingTeam) {
              message.error("Failed to resolve teams after toss");
              return;
            }

            setTeamA(battingTeam.team_id);
            setTeamB(bowlingTeam.team_id);

            setMatchState("toss_completed");
            setStep(UI_STEPS.PLAYERS);

            message.success("Toss completed successfully");
          } catch (err) {
            console.error("❌ Complete toss failed", err);
            message.error("Failed to complete toss");
          }
        }}
      >
        Complete Toss →
      </Button>
    </div>
  </Card>
)}



     
{/* ================= STEP 4 – PLAYERS ================= */}
{step === UI_STEPS.PLAYERS && (
  <Card
    title="Players"
    bordered={false}
    bodyStyle={{ padding: screens.md ? 16 : 8 }}
  >
    <Row gutter={screens.md ? 24 : 12}>
      {selectedMatchTeams.map((team) => {
        const players = teamPlayers[team.team_id] || [];

        return (
          <Col xs={24} md={12} key={team.team_id}>
            <Card
              size="small"
              bodyStyle={{ padding: 12 }}
              title={
                <div style={{ fontWeight: 600 }}>
                  {team.name}
                </div>
              }
              extra={
                screens.md && (
                  <Button
                    size="small"
                    type="link"
                    onClick={() => {
                      setTeamCreateTarget(team.team_id);
                      setIsPlayerModalOpen(true);
                    }}
                  >
                    + Add Player
                  </Button>
                )
              }
            >
              {/* MOBILE ADD PLAYER */}
              {!screens.md && (
                <Button
                  type="dashed"
                  block
                  size="small"
                  style={{ marginBottom: 8 }}
                  onClick={() => {
                    setTeamCreateTarget(team.team_id);
                    setIsPlayerModalOpen(true);
                  }}
                >
                  + Add Player
                </Button>
              )}

              {/* PLAYERS LIST */}
              {players.length === 0 ? (
                <Text type="secondary">No players added</Text>
              ) : (
                <div
                  style={{
                    maxHeight: screens.md ? 240 : 180,
                    overflowY: "auto",
                  }}
                >
                  {players.map((p) => (
                    <div
                      key={p.Player.player_id}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "6px 0",
                        borderBottom: "1px solid #f0f0f0",
                        fontSize: 13,
                      }}
                    >
                      <span>{p.Player.name}</span>
                      <Text type="secondary">{p.Player.role}</Text>
                    </div>
                  ))}
                </div>
              )}
            </Card>
          </Col>
        );
      })}
    </Row>

    {/* CTA */}
    <div
      style={{
        marginTop: 16,
        position: screens.md ? "static" : "sticky",
        bottom: 0,
        background: screens.md ? "transparent" : "#fff",
        paddingTop: screens.md ? 0 : 8,
        zIndex: 10,
      }}
    >
      <Button
        type="primary"
        block
        size={screens.md ? "middle" : "large"}
        onClick={startMatch}
      >
        Start Match 🏏
      </Button>
    </div>
  </Card>
)}



{/* ================= STEP 5 – LIVE ================= */}
{step === UI_STEPS.LIVE && !matchCompleted && innings && (
  <>
    {/* 🔵 STICKY SCOREBOARD */}
    {/* 🔗 OBS Overlay URL */}
<Card
  size="small"
  style={{
    marginBottom: screens.md ? 16 : 8,
    background: "#f0f5ff",
    border: "1px solid #adc6ff",
  }}
  bodyStyle={{ padding: screens.md ? 12 : 8 }}
>
  <div style={{ display: "flex", gap: 8 }}>
    <Input
      value={overlayUrl}
      disabled
      style={{
        fontWeight: 500,
        color: "#000",
        cursor: "text",
      }}
    />

    <Tooltip title="Copy OBS Overlay URL">
      <Button
        icon={<CopyOutlined />}
        type="primary"
        onClick={() => {
          navigator.clipboard.writeText(overlayUrl);
          message.success("Overlay URL copied!");
        }}
      />
    </Tooltip>
  </div>
</Card>
    <div
      style={{
        position: "sticky",
        top: 0,
        zIndex: 20,
        background: "#001529",
        padding: screens.md ? 16 : 12,
        borderRadius: screens.md ? 12 : 0,
        marginBottom: screens.md ? 16 : 8,
      }}
    >
      <div style={{ color: "#40a9ff", fontSize: 28, fontWeight: 700 }}>
        {innings.score} / {innings.wickets}
      </div>
      <div style={{ color: "#fff", fontSize: 14 }}>
        Overs {innings.overs}.{innings.balls} / {matchOvers}
      </div>
    </div>

    {/* 🟡 CURRENT PLAYERS */}
    <Card
      size="small"
      bodyStyle={{ padding: screens.md ? 12 : 8 }}
      style={{ marginBottom: screens.md ? 16 : 8 }}
    >
      <Row gutter={8}>
        <Col span={8}><b>Striker</b><br />{innings.striker?.name || "-"}</Col>
        <Col span={8}><b>Non-Striker</b><br />{innings.nonStriker?.name || "-"}</Col>
        <Col span={8}><b>Bowler</b><br />{innings.bowler?.name || "-"}</Col>
      </Row>
    </Card>

    {/* 🟥 INNINGS COMPLETE */}
    {innings.isInningsOver && inningsNo === 1 ? (
      <Card
        style={{
          background: "#fffbe6",
          border: "1px dashed #faad14",
        }}
      >
        <h3>Innings Complete</h3>
        <p>
          Score: <b>{innings.score}/{innings.wickets}</b>
        </p>
        <Button
          type="primary"
          block
          size="large"
          onClick={startSecondInnings}
        >
          Start 2nd Innings 🏏
        </Button>
      </Card>
    ) : (
      <>
        {/* 🔘 SCORING GRID */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: 8,
            marginBottom: 12,
          }}
        >
          {[0, 1, 2, 4, 6].map((r) => (
            <Button
              key={r}
              size="large"
              disabled={
                isInningsBreak ||
                innings.isInningsOver ||
                innings.pendingWicket ||
                innings.isOverComplete ||
                !innings.striker ||
                !innings.bowler
              }
              onClick={() => innings.bowlBall({ runs: r })}
            >
              {r}
            </Button>
          ))}

          <Button
            onClick={() => innings.bowlBall({ isWide: true })}
            disabled={!innings.striker}
          >
            Wide
          </Button>

          <Button
            onClick={() => innings.bowlBall({ isNoBall: true, runs: 1 })}
            disabled={!innings.striker}
          >
            No Ball
          </Button>

          <Button
            danger
            onClick={() => innings.bowlBall({ isWicket: true })}
            disabled={!innings.striker}
          >
            Wicket
          </Button>
        </div>
      </>
    )}

    {/* 🔽 BOTTOM ACTION (SUMMARY) */}
    <div
      style={{
        position: screens.md ? "static" : "sticky",
        bottom: 0,
        background: "#fff",
        paddingTop: 8,
        zIndex: 10,
      }}
    >
      <Button block onClick={() => setStep(UI_STEPS.SUMMARY)}>
        Go to Match Summary
      </Button>
    </div>

    {/* 🟥 WICKET FLOW */}
    {showWicketModal && (
      <Card
        style={{
          marginTop: 16,
          background: "#fff1f0",
          border: "1px solid #ff4d4f",
        }}
      >
        <h3>Wicket Fallen</h3>

        <Select
          placeholder="Wicket Type"
          style={{ width: "100%", marginBottom: 8 }}
          value={selectedWicketType}
          onChange={setSelectedWicketType}
        >
          <Option value="bowled">Bowled</Option>
          <Option value="caught">Caught</Option>
          <Option value="lbw">LBW</Option>
          <Option value="run_out">Run Out</Option>
          <Option value="stumped">Stumped</Option>
          <Option value="hit_wicket">Hit Wicket</Option>
        </Select>

        {["caught", "run_out"].includes(selectedWicketType) && (
          <Select
            placeholder="Fielder"
            style={{ width: "100%", marginBottom: 8 }}
            value={selectedFielder}
            onChange={setSelectedFielder}
          >
            {bowlers
              .filter(p => p.player_id !== innings.bowler?.player_id)
              .map(p => (
                <Option key={p.player_id} value={p.player_id}>
                  {p.name}
                </Option>
              ))}
          </Select>
        )}

        {selectedWicketType === "run_out" && (
          <Select
            placeholder="Who is out?"
            style={{ width: "100%", marginBottom: 8 }}
            value={runOutBatsman}
            onChange={setRunOutBatsman}
          >
            <Option value={innings.striker?.player_id}>
              {innings.striker?.name} (Striker)
            </Option>
            <Option value={innings.nonStriker?.player_id}>
              {innings.nonStriker?.name} (Non-Striker)
            </Option>
          </Select>
        )}

        <Select
          placeholder="Next Batter"
          style={{ width: "100%", marginBottom: 8 }}
          value={selectedNextBatter}
          onChange={setSelectedNextBatter}
        >
          {batters
            .filter(
              p =>
                p.player_id !== innings.striker?.player_id &&
                p.player_id !== innings.nonStriker?.player_id
            )
            .map(p => (
              <Option key={p.player_id} value={p.player_id}>
                {p.name}
              </Option>
            ))}
        </Select>

        <Button
          type="primary"
          block
          disabled={
            !selectedWicketType ||
            !selectedNextBatter ||
            (["caught", "run_out"].includes(selectedWicketType) &&
              !selectedFielder) ||
            (selectedWicketType === "run_out" && !runOutBatsman)
          }
          onClick={async () => {
            if (!lastSavedBallId) return;

            wicketUpdateLockedRef.current = true;

            await api.put(`/balls/${lastSavedBallId}`, {
              wicket: true,
              wicket_type: selectedWicketType,
              fielder_id: selectedFielder || null,
              batsman_id:
                selectedWicketType === "run_out"
                  ? runOutBatsman
                  : innings.striker.player_id,
            });

            innings.selectNextBatter(
              batters.find(p => p.player_id === selectedNextBatter),
              selectedWicketType === "run_out"
                ? runOutBatsman
                : innings.striker.player_id
            );

            setShowWicketModal(false);
            setSelectedWicketType(null);
            setSelectedFielder(null);
            setSelectedNextBatter(null);
            setRunOutBatsman(null);
            setLastSavedBallId(null);

            wicketUpdateLockedRef.current = false;
          }}
        >
          Confirm Wicket
        </Button>
      </Card>
    )}

    {/* 🟦 BOWLER SELECTION */}
    {showBowlerSelect && (
      <Card
        style={{
          marginTop: 16,
          background: "#e6f7ff",
          border: "1px solid #1890ff",
        }}
      >
        <h3>Select Next Bowler</h3>

        <Select
          style={{ width: "100%", marginBottom: 8 }}
          value={selectedNextBowler}
          onChange={setSelectedNextBowler}
        >
          {bowlers.map((b) => (
            <Option key={b.player_id} value={b.player_id}>
              {b.name}
            </Option>
          ))}
        </Select>

        <Button
          type="primary"
          block
          disabled={!selectedNextBowler}
          onClick={() => {
            innings.selectNextBowler(
              bowlers.find(b => b.player_id === selectedNextBowler)
            );
            setShowBowlerSelect(false);
            setSelectedNextBowler(null);
          }}
        >
          Start Next Over
        </Button>
      </Card>
    )}
  </>
)}




{/* ================= STEP 6 – SUMMARY ================= */}
{step === UI_STEPS.SUMMARY && (
  <Card
    bordered={false}
    title="Match Summary"
    bodyStyle={{ padding: screens.md ? 16 : 8 }}
  >
    {summaryLoading || !summaryMatch || summaryInnings.length === 0 ? (
      <Text type="secondary">Loading summary…</Text>
    ) : (
      <>
        {/* 🏆 RESULT */}
        <div
          style={{
            background: "#f6ffed",
            border: "1px solid #b7eb8f",
            borderRadius: 8,
            padding: 12,
            marginBottom: 16,
            fontSize: screens.md ? 18 : 16,
            fontWeight: 600,
            textAlign: "center",
          }}
        >
          {getMatchResultText()}
        </div>

        {/* 📋 MATCH INFO */}
        <Card size="small" bodyStyle={{ padding: 12 }}>
          <Row gutter={screens.md ? 16 : 8}>
            <Col xs={24} md={8}>
              <b>Match</b><br />
              {summaryMatch.name}
            </Col>
            <Col xs={12} md={8}>
              <b>Status</b><br />
              {summaryMatch.status}
            </Col>
            <Col xs={12} md={8}>
              <b>Overs</b><br />
              {summaryMatch.overs}
            </Col>
          </Row>
        </Card>

        {/* 🏏 INNINGS */}
        <div style={{ marginTop: 16 }}>
          {summaryInnings.map((inn, idx) => {
            const totals = getInningTotals(inn);

            return (
              <Card
                key={inn.inning_id}
                size="small"
                style={{ marginBottom: 12 }}
                title={`Innings ${idx + 1} – ${getTeamNameById(
                  inn.batting_team_id
                )}`}
              >
                <Row gutter={screens.md ? 16 : 8}>
                  <Col xs={8}><b>Runs</b><br />{totals.runs}</Col>
                  <Col xs={8}><b>Wkts</b><br />{totals.wickets}</Col>
                  <Col xs={8}><b>Overs</b><br />{totals.overs}</Col>

                  {idx === 1 && (
                    <Col xs={24} style={{ marginTop: 8 }}>
                      <b>Target</b>:{" "}
                      {getInningTotals(summaryInnings[0]).runs + 1}
                    </Col>
                  )}
                </Row>
              </Card>
            );
          })}
        </div>

        {/* 🔽 CTA */}
        <div
          style={{
            marginTop: 16,
            position: screens.md ? "static" : "sticky",
            bottom: 0,
            background: "#fff",
            paddingTop: 8,
            zIndex: 10,
          }}
        >
          <Button
            type="primary"
            block
            size={screens.md ? "middle" : "large"}
            onClick={() => {
              setStep(UI_STEPS.MATCH);
              setMatchId(null);
              setSummaryInnings([]);
              setSummaryBallsByInning({});
              setMatchCompleted(false);
            }}
          >
            New Match
          </Button>
        </div>
      </>
    )}
  </Card>
)}



      {/* ================= MODALS ================= */}
      <TournamentFormModal
        open={showTournamentModal}
        onClose={() => setShowTournamentModal(false)}
        onSuccess={loadTournaments}
      />

 

    <TeamFormModal
  key={teamSlot}
  open={showTeamModal}
  onClose={() => {
    setShowTeamModal(false);
    setTeamSlot(null);
  }}
  onSuccess={async (newTeam) => {
    await loadAllTeams();

    setSelectedTeams(prev => ({
      ...prev,
      [teamSlot]: newTeam.team_id,
    }));

    setShowTeamModal(false);
    setTeamSlot(null);
  }}
/>




      <PlayerFormModal
        open={isPlayerModalOpen}
        teamId={teamCreateTarget}
        editingPlayer={null}
        onClose={() => {
          setIsPlayerModalOpen(false);
          setTeamCreateTarget(null);
        }}
        onSuccess={() => {
          if (teamCreateTarget) loadTeamPlayers(teamCreateTarget);
        }}
      />



    </div>
  )

  }
